<app-s01-navigation></app-s01-navigation>
<main class="recommendations-page" #recommendationsRef>
  <app-a04-picture-element
    width="1920"
    height="1080"
    webpSrcset="{{ '/assets/images/background/background-light.webp' | assetpipe }}"
    defaultSrc="{{ '/assets/images/background/background-light.jpg' | assetpipe }}"
    alt=""
    class="browse-title-background"
  >
  </app-a04-picture-element>
  <app-c01-tv-frame customClass="page-tv-frame">
    <img
      *ngFor="let i of [6, 5, 4, 3, 2, 1]"
      attr.data-transition="{{ i }}"
      src="{{ baseHref }}/assets/images/recommendations/{{ i }}.jpg"
      alt=""
      class="recommendations-img"
    />
  </app-c01-tv-frame>
  <app-c02-remote-control-buttons
    [featureName]="featureName"
    [stepIndex]="stepIndex"
    [tooltipCopy]="currentStep.tooltipCopy"
    [buttons]="currentStep.activeButtonKeys"
    [disabled]="isRemoteDisabled"
  ></app-c02-remote-control-buttons>
  <app-c04-opening-screen [featureName]="featureName"></app-c04-opening-screen>
  <app-c06-end-screen [featureName]="featureName"></app-c06-end-screen>
  <app-a03-disclaimer-paragraph [featureName]="featureName"></app-a03-disclaimer-paragraph>
  <app-a05-custom-cta></app-a05-custom-cta>
  <app-c03-question-mark-modal [featureName]="featureName"></app-c03-question-mark-modal>
</main>
